// Create a reusable function to handle mutations
function handleMutations(mutationsList, observer) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            // Function 1: Update .loox-rating-label elements
            const looxRatingLabels = document.querySelectorAll('.loox-rating .loox-rating-label');
            looxRatingLabels.forEach((looxRatingLabel) => {
                if (!looxRatingLabel.dataset.updated) {
                    // Update the rating number (e.g., 4.X) to 4.7
                    const ratingRegex = /4\.\d/;
                    looxRatingLabel.innerHTML = looxRatingLabel.innerHTML.replace(ratingRegex, '4.9');

                    // If there's a span.greyed-out, update its content
                    const greyedOutSpan = looxRatingLabel.querySelector('.greyed-out');
                    if (greyedOutSpan) {
                        greyedOutSpan.innerHTML = '(695)';
                    } else {
                        // Else, replace the content inside parentheses
                        const parenthesisRegex = /\(.*?\)/;
                        looxRatingLabel.innerHTML = looxRatingLabel.innerHTML.replace(parenthesisRegex, '(50,000+ verkocht)');
                    }

                    looxRatingLabel.style.fontWeight = 'normal';
                    looxRatingLabel.dataset.updated = 'true';
                }
            });

            // Function 2: Update elements inside .loox-trust-badge-container
            const trustBadgeContainers = document.querySelectorAll('.loox-trust-badge-container');
            trustBadgeContainers.forEach((container) => {
                const averageRatingElement = container.querySelector('.loox-trust-badge-widget-ratings__average-rating');
                const ratersCountElement = container.querySelector('.loox-trust-badge-widget-ratings__raters-count');
                const ratersTitleElement = container.querySelector('.loox-trust-badge-widget-ratings__raters-title');
                const paperElement = container.querySelector('.loox-trust-badge-widget.lxs-paper');
                
                if (averageRatingElement && !averageRatingElement.dataset.updated) {
                    averageRatingElement.innerHTML = '4.9';
                    averageRatingElement.style.fontWeight = 'normal';
                    averageRatingElement.dataset.updated = 'true';
                }
                if (ratersCountElement && !ratersCountElement.dataset.updated) {
                    ratersCountElement.innerHTML = '695';
                    ratersCountElement.style.fontWeight = 'normal';
                    ratersCountElement.dataset.updated = 'true';
                }
                if (ratersTitleElement && !ratersTitleElement.dataset.updated) {
                    ratersTitleElement.style.fontWeight = 'normal';
                    ratersTitleElement.dataset.updated = 'true';
                }

                // Set font size based on viewport width
                if (paperElement && !paperElement.dataset.fontsizeUpdated) {
                    const updateFontSize = () => {
                        const viewportWidth = window.innerWidth;
                        if (viewportWidth < 768) {
                            paperElement.style.fontSize = '24px';
                        } else {
                            paperElement.style.fontSize = '30px';
                        }
                    };

                    updateFontSize();
                    window.addEventListener('resize', updateFontSize);

                    paperElement.dataset.fontsizeUpdated = 'true';
                }
            });
        }
    }
}

// Initialize the MutationObserver
const observer = new MutationObserver(handleMutations);

// Start observing the document body for added nodes and subtree modifications
observer.observe(document.body, { childList: true, subtree: true });
